// Relative Imports
import { Container } from "./styles";

const Responsive = ({ children }) => {
  return <Container>{children}</Container>;
};

export default Responsive;
